/** メッセージAI (受信箱 + 物件設定) の基点. ナビはここを指し, index は受信箱へ redirect する. */
export const ROUTE_PATH = '/clean/cleaner/messages' as const
